"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Confirm = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Confirm = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.8567 6.15796C20.0502 6.36591 20.0474 6.70002 19.8503 6.90422L9.29033 17.8488C9.09744 18.0487 8.78891 18.0506 8.59384 17.8531L4.15384 13.357C3.95458 13.1553 3.94803 12.8212 4.13921 12.6109C4.33039 12.4006 4.64691 12.3937 4.84617 12.5955L8.93596 16.7369L19.1497 6.15119C19.3467 5.94699 19.6633 5.95002 19.8567 6.15796Z"
    })
  });
};
exports.Confirm = Confirm;